<template>
  <div v-if="plate">
    <template v-if="appQuestion === 'prosperity_life'">
      <div class="d-flex justify-space-between">
        <h2>
          In the past 2 years, have you been diagnosed or received treatment
          for:
        </h2>
        <PlateHealthPriority />
      </div>

      <p class="mt-4">
        The use of alcohol or drugs; or been advised to restrict the use of
        alcohol or drugs?
      </p>

      <v-radio-group v-model="plate.prosperity.q1" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Complications of diabetes such as diabetic coma or insulin shock or had
        an amputation due to complications of an disease?
      </p>

      <v-radio-group v-model="plate.prosperity.q2" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Heart attack, angina (chest pain), congestive heart failure,
        cardiomyopathy, stroke, TIA, aneurysm or had heart or circulatory
        surgery?
      </p>

      <v-radio-group v-model="plate.prosperity.q3" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h2 class="mt-6">In the past 2 years, have you:</h2>

      <p class="mt-4">
        Had more than 1 conviction for reckless driving or for driving under the
        influence of alcohol or drugs? (DUI or DWI)
      </p>

      <v-radio-group v-model="plate.prosperity.q4" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h2 class="mt-6">
        In the past 3 years, have you been diagnosed, treated, or prescribed
        medication for:
      </h2>

      <p class="mt-4">
        Leukemia, or cancer? (but excluding basal/squamous cell skin cancer)
      </p>

      <v-radio-group v-model="plate.prosperity.q5" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>
    <template v-else>
      <div class="d-flex justify-space-between">
        <h2>Within the past 2 years have YOU been diagnosed, treated:</h2>
        <PlateHealthPriority />
      </div>

      <p class="mt-4">
        Angina(chest pain), heart or circulatory surgery, heart attack or
        received a pacemaker or stent?
      </p>

      <v-radio-group v-model="plate.liberty.isAngina" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">Stroke, TIA or paralysis?</p>

      <v-radio-group v-model="plate.liberty.isParalysis" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Cancer, or receive chemotherapy? (Excludes basal cell skin cancer)
      </p>

      <v-radio-group v-model="plate.liberty.isCancer" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Diabetic complications? ie:kidney, nerve, circulatory, eye, diabetic
        coma or insulin shock?
      </p>

      <v-radio-group v-model="plate.liberty.isDiabetic" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Chronic hepatitis or pancreatitis, Hepatitis C, cirrhosis of the liver,
        kidney, disease, or Systematic Lupus?
      </p>

      <v-radio-group v-model="plate.liberty.isHepatitis" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        MS, Parkinson's disease, or required the use of a walker, wheelchair, or
        electric scooter due to chronic illness or disease?
      </p>

      <v-radio-group v-model="plate.liberty.isParkinson" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        In the last two years, have you plead guilty to or been convicted of a
        felony or misdemeanor or do you have such a charge currently pending
        against you?
      </p>

      <v-radio-group v-model="plate.liberty.isFelony" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>

    <PlateFooter :onBack="onBack" :onSubmit="onSubmit" :isLoading="isLoading" />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import PlateHealthPriority from '@/components/lead/plates/PlateHealthPriority';
import { mapGetters } from 'vuex';

export default {
  name: 'DisabledHealthFirstPlate',
  components: {
    PlateHealthPriority,
    PlateFooter,
  },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      appQuestion: 'plates/appQuestion',
    }),
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.disabledHealthFirst
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.health);
    },
    onSubmit() {
      if (this.appQuestion === 'prosperity_life') {
        if (Object.values(this.plate.prosperity).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gb');
        }
      } else {
        if (Object.values(this.plate.liberty).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gb');
        }
      }

      this.$store.commit('plates/setStep', PlatesSteps.disabledHealthSecond);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style></style>